import * as i0 from '@angular/core';
import { Injectable, inject, Component, ChangeDetectionStrategy, Input, NgModule, Optional, isDevMode } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@spartacus/cart/base/root';
import { PromotionLocation, AbstractOrderType, CartOutlets } from '@spartacus/cart/base/root';
import * as i4 from '@spartacus/core';
import { OCC_USER_ID_ANONYMOUS, RoutingService, UrlModule, I18nModule, ProductScope, ConfigModule, LoggerService, provideDefaultConfig } from '@spartacus/core';
import * as i1 from '@spartacus/storefront';
import { IconModule, ICON_TYPE, provideOutlet, OutletPosition, BtnLikeLinkModule, ProductListOutlets } from '@spartacus/storefront';
import * as i3$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { AbstractOrderContext } from '@spartacus/cart/base/components';
import { EMPTY, of } from 'rxjs';
import { map, take, filter } from 'rxjs/operators';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = (a0, a1, a2) => ({
  ownerType: a0,
  entityKey: a1,
  displayOnly: a2
});
const _c1 = (a0, a1) => ({
  cxRoute: a0,
  params: a1
});
function ConfigureCartEntryComponent_ng_container_0_ng_container_1_label_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_container_1_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵtemplate(1, ConfigureCartEntryComponent_ng_container_0_ng_container_1_label_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const configureText_r1 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isDisabled())("ngIfThen", configureText_r1);
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_container_1_a_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_container_1_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, ConfigureCartEntryComponent_ng_container_0_ng_container_1_a_2_ng_container_3_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const abstractOrderKey_r3 = i0.ɵɵnextContext(2).ngIf;
    const configureText_r1 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 5, i0.ɵɵpureFunction2(13, _c1, ctx_r1.getRoute(), i0.ɵɵpureFunction3(9, _c0, ctx_r1.retrieveOwnerTypeFromAbstractOrderType(abstractOrderKey_r3), ctx_r1.retrieveEntityKey(abstractOrderKey_r3), ctx_r1.getDisplayOnly()))))("queryParams", i0.ɵɵpipeBind1(2, 7, ctx_r1.queryParams$));
    i0.ɵɵattribute("aria-describedby", ctx_r1.getResolveIssuesA11yDescription());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isDisabled())("ngIfThen", configureText_r1);
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfigureCartEntryComponent_ng_container_0_ng_container_1_label_1_Template, 2, 2, "label", 2)(2, ConfigureCartEntryComponent_ng_container_0_ng_container_1_a_2_Template, 4, 16, "a", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isDisabled());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isDisabled());
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "configurator.header.displayConfiguration"), "");
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "configurator.header.editConfiguration"), " ");
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_template_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "configurator.header.resolveIssues"), " ");
  }
}
function ConfigureCartEntryComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ConfigureCartEntryComponent_ng_container_0_ng_template_2_ng_container_0_Template, 3, 3, "ng-container", 1)(1, ConfigureCartEntryComponent_ng_container_0_ng_template_2_ng_container_1_Template, 3, 3, "ng-container", 1)(2, ConfigureCartEntryComponent_ng_container_0_ng_template_2_ng_container_2_Template, 3, 3, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.getDisplayOnly());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.getDisplayOnly() && !ctx_r1.msgBanner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.getDisplayOnly() && ctx_r1.msgBanner);
  }
}
function ConfigureCartEntryComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfigureCartEntryComponent_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 1)(2, ConfigureCartEntryComponent_ng_container_0_ng_template_2_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.cartEntry);
  }
}
const _c2 = a0 => ({
  count: a0
});
function ConfiguratorIssuesNotificationComponent_ng_container_0_ng_container_1_ng_container_5_cx_configure_cart_entry_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-configure-cart-entry", 4);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    let tmp_7_0;
    const quantityControl_r1 = i0.ɵɵnextContext().ngIf;
    const orderEntry_r2 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cartEntry", orderEntry_r2)("readOnly", (tmp_7_0 = i0.ɵɵpipeBind1(1, 4, ctx_r2.readonly$)) !== null && tmp_7_0 !== undefined ? tmp_7_0 : false)("msgBanner", true)("disabled", quantityControl_r1.disabled);
  }
}
function ConfiguratorIssuesNotificationComponent_ng_container_0_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorIssuesNotificationComponent_ng_container_0_ng_container_1_ng_container_5_cx_configure_cart_entry_1_Template, 2, 6, "cx-configure-cart-entry", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r2 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.shouldShowButton$) && (orderEntry_r2 == null ? null : orderEntry_r2.product == null ? null : orderEntry_r2.product.configurable));
  }
}
function ConfiguratorIssuesNotificationComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-icon", 1);
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵtemplate(5, ConfiguratorIssuesNotificationComponent_ng_container_0_ng_container_1_ng_container_5_Template, 3, 3, "ng-container", 0);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r2.iconTypes.ERROR);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r2.getErrorMessageId(orderEntry_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 4, "configurator.notificationBanner.numberOfIssues", i0.ɵɵpureFunction1(9, _c2, ctx_r2.getNumberOfIssues(orderEntry_r2))), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 7, ctx_r2.quantityControl$));
  }
}
function ConfiguratorIssuesNotificationComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorIssuesNotificationComponent_ng_container_0_ng_container_1_Template, 7, 11, "ng-container", 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r2 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasIssues(orderEntry_r2) && !i0.ɵɵpipeBind1(2, 1, ctx_r2.readonly$));
  }
}
const _c3 = (a0, a1) => ({
  attribute: a0,
  value: a1
});
function ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "configurator.a11y.cartEntryInfoIntro"), " ");
  }
}
function ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const info_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-describedby", ctx_r2.getHiddenConfigurationInfoId(i_r2));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r2.getHiddenConfigurationInfoId(i_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 5, "configurator.a11y.cartEntryInfo", i0.ɵɵpureFunction2(8, _c3, info_r1.configurationLabel, info_r1.configurationValue)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", info_r1 == null ? null : info_r1.configurationLabel, ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", info_r1 == null ? null : info_r1.configurationValue, " ");
  }
}
function ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_1_span_1_Template, 3, 3, "span", 1)(2, ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_2_Template, 8, 11, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const orderEntry_r4 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_4_0 = orderEntry_r4.configurationInfos == null ? null : orderEntry_r4.configurationInfos.length) !== null && tmp_4_0 !== undefined ? tmp_4_0 : 0 > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", orderEntry_r4.configurationInfos);
  }
}
function ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_2_cx_configure_cart_entry_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-configure-cart-entry", 9);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    let tmp_7_0;
    const quantityControl_r5 = i0.ɵɵnextContext().ngIf;
    const orderEntry_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cartEntry", orderEntry_r4)("readOnly", (tmp_7_0 = i0.ɵɵpipeBind1(1, 4, ctx_r2.readonly$)) !== null && tmp_7_0 !== undefined ? tmp_7_0 : false)("msgBanner", false)("disabled", quantityControl_r5.disabled);
  }
}
function ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_2_cx_configure_cart_entry_1_Template, 2, 6, "cx-configure-cart-entry", 8);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.shouldShowButton$) && (orderEntry_r4 == null ? null : orderEntry_r4.product == null ? null : orderEntry_r4.product.configurable));
  }
}
function ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 0)(2, ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_ng_container_2_Template, 3, 3, "ng-container", 0);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasStatus(orderEntry_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 2, ctx_r2.quantityControl$));
  }
}
function ConfiguratorCartEntryInfoComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryInfoComponent_ng_container_0_ng_container_1_Template, 4, 4, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r4 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isAttributeBasedConfigurator(orderEntry_r4));
  }
}
function ConfigureProductComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ConfigureProductComponent_ng_container_0_ng_container_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const product_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.navigateToConfigurator(product_r2));
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 2, ctx_r2.getAriaLabelTranslationKey(product_r2.configuratorType)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, ctx_r2.getTranslationKey(product_r2.configuratorType)), " ");
  }
}
function ConfigureProductComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfigureProductComponent_ng_container_0_ng_container_1_Template, 5, 6, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r2 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", product_r2.configurable && !ctx_r2.isReadOnlyBaseProduct(product_r2));
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_8_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 12);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxNumeric");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const lineItem_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "configurator.attribute.quantity"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, lineItem_r3 == null ? null : lineItem_r3.formattedQuantity));
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_8_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 12);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const lineItem_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "configurator.overviewForm.itemPrice"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(lineItem_r3 == null ? null : lineItem_r3.formattedPrice);
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtemplate(6, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_8_ng_container_6_Template, 7, 6, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵtemplate(8, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_8_ng_container_8_Template, 6, 4, "ng-container", 0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const lineItem_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-describedby", ctx_r1.getHiddenItemInfoId(i_r4));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.getHiddenItemInfoId(i_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getHiddenItemInfo(lineItem_r3), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", lineItem_r3 == null ? null : lineItem_r3.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", lineItem_r3 == null ? null : lineItem_r3.formattedQuantity);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", lineItem_r3 == null ? null : lineItem_r3.formattedPrice);
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 2);
    i0.ɵɵlistener("click", function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleItems());
    });
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 4);
    i0.ɵɵtemplate(8, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_div_8_Template, 9, 6, "div", 5);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const numberOfItems_r5 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 7, "configurator.header.items", i0.ɵɵpureFunction1(12, _c2, numberOfItems_r5)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-expanded", !ctx_r1.hideItems)("aria-label", ctx_r1.getItemsMsg(numberOfItems_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getButtonText(), " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("open", !ctx_r1.hideItems);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(9, 10, ctx_r1.lineItems$));
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_3_cx_configure_cart_entry_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-configure-cart-entry", 14);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    let tmp_7_0;
    const quantityControl_r6 = i0.ɵɵnextContext().ngIf;
    const orderEntry_r7 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cartEntry", orderEntry_r7)("readOnly", (tmp_7_0 = i0.ɵɵpipeBind1(1, 4, ctx_r1.readonly$)) !== null && tmp_7_0 !== undefined ? tmp_7_0 : false)("msgBanner", false)("disabled", quantityControl_r6.disabled);
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_3_cx_configure_cart_entry_1_Template, 2, 6, "cx-configure-cart-entry", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r7 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.shouldShowButton$) && (orderEntry_r7 == null ? null : orderEntry_r7.product == null ? null : orderEntry_r7.product.configurable));
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_1_Template, 10, 14, "ng-container", 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_ng_container_3_Template, 3, 3, "ng-container", 0);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.numberOfLineItems$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r1.quantityControl$));
  }
}
function ConfiguratorCartEntryBundleInfoComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_ng_container_1_Template, 5, 6, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r7 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isBundleBasedConfigurator(orderEntry_r7));
  }
}
var CommonConfigurator;
(function (CommonConfigurator) {
  /**
   * Possible types of owners: Product, cart or order entry
   */
  let OwnerType;
  (function (OwnerType) {
    OwnerType["PRODUCT"] = "product";
    OwnerType["CART_ENTRY"] = "cartEntry";
    OwnerType["ORDER_ENTRY"] = "orderEntry";
    OwnerType["QUOTE_ENTRY"] = "quoteEntry";
    OwnerType["SAVED_CART_ENTRY"] = "savedCartEntry";
  })(OwnerType = CommonConfigurator.OwnerType || (CommonConfigurator.OwnerType = {}));
})(CommonConfigurator || (CommonConfigurator = {}));
/**
 * Possible configurator types
 */
var ConfiguratorType = /*#__PURE__*/function (ConfiguratorType) {
  ConfiguratorType["CPQ"] = "CLOUDCPQCONFIGURATOR";
  ConfiguratorType["VARIANT"] = "CPQCONFIGURATOR";
  ConfiguratorType["TEXTFIELD"] = "TEXTFIELD";
  return ConfiguratorType;
}(ConfiguratorType || {});
/**
 * Configurator types including this postfix are
 * treated as view-only
 */
const ReadOnlyPostfix = '_READ_ONLY';
/**
 * Statuses that can occur in the generic configuration
 * status summary
 */
var OrderEntryStatus = /*#__PURE__*/function (OrderEntryStatus) {
  OrderEntryStatus["Success"] = "SUCCESS";
  OrderEntryStatus["Info"] = "INFO";
  OrderEntryStatus["Warning"] = "WARNING";
  OrderEntryStatus["Error"] = "ERROR";
  return OrderEntryStatus;
}(OrderEntryStatus || {});
/**
 *
 * An enum representing ConfigurationInfo fields.
 */
var ConfigurationInfoFields = /*#__PURE__*/function (ConfigurationInfoFields) {
  ConfigurationInfoFields["KEY"] = "KEY";
  ConfigurationInfoFields["NAME"] = "NAME";
  ConfigurationInfoFields["QTY"] = "QTY";
  ConfigurationInfoFields["FORMATTED_PRICE"] = "FORMATTED_PRICE";
  ConfigurationInfoFields["PRICE_VALUE"] = "PRICE_VALUE";
  return ConfigurationInfoFields;
}(ConfigurationInfoFields || {});
/**
 *
 * An enum representing ConfigurationInfo special fields.
 */
var ConfigurationInfoSpecialFields = /*#__PURE__*/function (ConfigurationInfoSpecialFields) {
  ConfigurationInfoSpecialFields["VERSION"] = "CI#@#VERSION";
  ConfigurationInfoSpecialFields["CURRENCY"] = "CI#@#CURRENCY";
  ConfigurationInfoSpecialFields["LINE_ITEM"] = "LI";
  ConfigurationInfoSpecialFields["LINE_ITEM_DELIMITER"] = "#";
  return ConfigurationInfoSpecialFields;
}(ConfigurationInfoSpecialFields || {});
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const initialIndicator = 'INITIAL';
class ConfiguratorModelUtils {
  /**
   * Compiles a unique key for a configuration owner from id and type
   * @param owner Specifies the owner of a product configuration
   * @returns Owner key
   */
  static getOwnerKey(ownerType, ownerId) {
    if (!ownerId || !ownerType) {
      throw new Error('We expect an owner ID and an owner type');
    }
    return ownerType + '/' + ownerId;
  }
  /**
   * Creates an initial owner object
   * @returns Initial owner
   */
  static createInitialOwner() {
    return {
      key: initialIndicator,
      configuratorType: initialIndicator,
      id: initialIndicator,
      type: CommonConfigurator.OwnerType.PRODUCT
    };
  }
  /**
   * Checks if an owner is an initial one
   * @param owner Owner
   * @returns Is owner initial?
   */
  static isInitialOwner(owner) {
    return owner.configuratorType === initialIndicator;
  }
  /**
   * Creates a configuration owner object based on its essential attributes
   * @param ownerType Owner type (Does it refer to product, cart or order?)
   * @param ownerId Owner identifier
   * @param configuratorType Configurator type
   * @returns Owner
   */
  static createOwner(ownerType, ownerId, configuratorType = ConfiguratorType.VARIANT) {
    return {
      type: ownerType,
      id: ownerId,
      configuratorType: configuratorType,
      key: ConfiguratorModelUtils.getOwnerKey(ownerType, ownerId)
    };
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Utilities for generic configuration
 */
let CommonConfiguratorUtilsService = /*#__PURE__*/(() => {
  class CommonConfiguratorUtilsService {
    constructor(userIdService) {
      this.userIdService = userIdService;
    }
    /**
     * Compiles a unique key for a configuration owner and sets it into the 'key'
     * attribute
     * @param {CommonConfigurator.Owner }owner - Specifies the owner of a product configuration
     */
    setOwnerKey(owner) {
      owner.key = ConfiguratorModelUtils.getOwnerKey(owner.type, owner.id);
    }
    /**
     * Composes owner ID from document ID and entry number
     * @param {string} documentId - ID of document the entry is part of, like the order or quote code
     * @param {string} entryNumber - Entry number
     * @returns {string} - owner ID
     */
    getComposedOwnerId(documentId, entryNumber) {
      return documentId + '+' + entryNumber;
    }
    /**
     * Decomposes an owner ID into documentId and entryNumber
     * @param {string} ownerId - ID of owner
     * @returns {any} object containing documentId and entryNumber
     */
    decomposeOwnerId(ownerId) {
      const parts = ownerId.split('+');
      if (parts.length !== 2) {
        throw new Error('We only expect 2 parts in ownerId, separated by +, but was: ' + ownerId);
      }
      const result = {
        documentId: parts[0],
        entryNumber: parts[1]
      };
      return result;
    }
    /**
     * Gets cart ID (which can be either its guid or its code)
     * @param {Cart} cart - Cart
     * @returns {string} - Cart identifier
     */
    getCartId(cart) {
      const cartId = cart?.user?.uid === OCC_USER_ID_ANONYMOUS ? cart.guid : cart?.code;
      if (!cartId) {
        throw new Error('Cart ID is not defined');
      }
      return cartId;
    }
    /**
     * Verifies whether the item has any issues.
     *
     * @param {OrderEntry} cartItem - Cart item
     * @returns {boolean} - whether there are any issues
     */
    hasIssues(cartItem) {
      return this.getNumberOfIssues(cartItem) > 0;
    }
    /**
     * Retrieves the number of issues at the cart item.
     *
     * @param {OrderEntry} cartItem - Cart item
     * @returns {number} - the number of issues at the cart item
     */
    getNumberOfIssues(cartItem) {
      let numberOfIssues = 0;
      cartItem?.statusSummaryList?.forEach(statusSummary => {
        if (statusSummary.status === OrderEntryStatus.Error) {
          const numberOfIssuesFromStatus = statusSummary.numberOfIssues;
          numberOfIssues = numberOfIssuesFromStatus ? numberOfIssuesFromStatus : 0;
        }
      });
      return numberOfIssues;
    }
    /**
     * Verifies whether the configurator type is an attribute based one.
     *
     * @param {string} configuratorType - Configurator type
     * @returns {boolean} - 'True' if the expected configurator type, otherwise 'false'
     */
    isAttributeBasedConfigurator(configuratorType) {
      if (configuratorType) {
        return configuratorType === ConfiguratorType.VARIANT || configuratorType === ConfiguratorType.TEXTFIELD;
      }
      return false;
    }
    /**
     * Verifies whether the configurator type is a bundle based one.
     *
     * @param {string} configuratorType - Configurator type
     * @returns {boolean} - 'True' if the expected configurator type, otherwise 'fasle'
     */
    isBundleBasedConfigurator(configuratorType) {
      if (configuratorType) {
        return configuratorType === ConfiguratorType.CPQ;
      }
      return false;
    }
    /**
     * Determines whether we are in the context of an active cart
     * @param cartItemContext Cart item context
     * @returns Item part of an active cart?
     */
    isActiveCartContext(cartItemContext) {
      return (cartItemContext?.location$ ?? EMPTY).pipe(map(location => location !== PromotionLocation.SaveForLater && location !== PromotionLocation.SavedCart));
    }
    /**
     * Reads slots from layout config, taking the breakpoint into account
     * @param layoutConfig Layout config
     * @param templateName Page template name
     * @param sectionName Section name like 'header'
     * @param breakPoint Current breakpoint
     * @returns Array of slots
     */
    getSlotsFromLayoutConfiguration(layoutConfig, templateName, sectionName, breakPoint) {
      const slots = layoutConfig.layoutSlots;
      if (slots) {
        const slotsForTemplate = slots[templateName];
        const slotGroupForSection = slotsForTemplate[sectionName];
        const slotConfigForBreakpoint = slotGroupForSection[breakPoint];
        return slotConfigForBreakpoint['slots'];
      } else {
        return [];
      }
    }
    static {
      this.ɵfac = function CommonConfiguratorUtilsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommonConfiguratorUtilsService)(i0.ɵɵinject(i4.UserIdService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CommonConfiguratorUtilsService,
        factory: CommonConfiguratorUtilsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CommonConfiguratorUtilsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfigureCartEntryComponent = /*#__PURE__*/(() => {
  class ConfigureCartEntryComponent {
    /**
     * Verifies whether the entry has any issues.
     *
     * @returns - whether there are any issues
     */
    hasIssues() {
      return this.commonConfigUtilsService.hasIssues(this.cartEntry);
    }
    /**
     * Retrieves owner for an abstract order type
     *
     * @returns - an owner type
     */
    retrieveOwnerTypeFromAbstractOrderType(abstractOrderKey) {
      switch (abstractOrderKey.type) {
        case AbstractOrderType.ORDER:
          {
            return CommonConfigurator.OwnerType.ORDER_ENTRY;
          }
        case AbstractOrderType.QUOTE:
          {
            return CommonConfigurator.OwnerType.QUOTE_ENTRY;
          }
        case AbstractOrderType.SAVED_CART:
          {
            return CommonConfigurator.OwnerType.SAVED_CART_ENTRY;
          }
        default:
          {
            return CommonConfigurator.OwnerType.CART_ENTRY;
          }
      }
    }
    /**
     * Verifies whether the cart entry has an order code, retrieves a composed owner ID
     * and concatenates a corresponding entry number.
     *
     * @returns - an entry key
     */
    retrieveEntityKey(abstractOrderKey) {
      const entryNumber = this.cartEntry.entryNumber;
      if (entryNumber === undefined) {
        throw new Error('No entryNumber present in entry');
      }
      return abstractOrderKey.type !== AbstractOrderType.CART ? this.commonConfigUtilsService.getComposedOwnerId(abstractOrderKey.id, entryNumber) : entryNumber.toString();
    }
    /**
     * Retrieves a corresponding route depending whether the configuration is read only or not.
     *
     * @returns - a route
     */
    getRoute() {
      const configuratorType = this.cartEntry.product?.configuratorType;
      return !this.readOnly || configuratorType?.endsWith(ReadOnlyPostfix) ? 'configure' + configuratorType : 'configureOverview' + configuratorType;
    }
    /**
     * Retrieves the state of the configuration.
     *
     *  @returns - 'true' if the configuration is read only or configurator type contains a read-only postfix, otherwise 'false'
     */
    getDisplayOnly() {
      const configuratorType = this.cartEntry.product?.configuratorType;
      return this.readOnly || !configuratorType || configuratorType.endsWith(ReadOnlyPostfix);
    }
    /**
     * Verifies whether the link to the configuration is disabled.
     *
     *  @returns - 'true' if the the configuration is not read only, otherwise 'false'
     */
    isDisabled() {
      return this.readOnly ? false : this.disabled;
    }
    /**
     * Retrieves the additional resolve issues accessibility description.
     *
     * @returns - If there is a 'resolve issues' link, the ID to the element with additional description will be returned.
     */
    getResolveIssuesA11yDescription() {
      const errorMsgId = 'cx-error-msg-' + this.cartEntry.entryNumber;
      return !this.getDisplayOnly() && this.msgBanner ? errorMsgId : undefined;
    }
    isInCheckout() {
      return this.routingService.getRouterState().pipe(map(routerState => {
        return routerState.state.semanticRoute === 'checkoutReviewOrder';
      }));
    }
    constructor(commonConfigUtilsService) {
      this.commonConfigUtilsService = commonConfigUtilsService;
      this.routingService = inject(RoutingService);
      this.abstractOrderContext = inject(AbstractOrderContext, {
        optional: true
      });
      // we default to active cart as owner in case no context is provided
      // in this case no id of abstract order is needed
      this.abstractOrderKey$ = this.abstractOrderContext ? this.abstractOrderContext.key$ : of({
        type: AbstractOrderType.CART
      });
      this.queryParams$ = this.isInCheckout().pipe(map(isInCheckout => ({
        forceReload: true,
        resolveIssues: this.msgBanner && this.hasIssues(),
        navigateToCheckout: isInCheckout,
        productCode: this.cartEntry.product?.code
      })));
    }
    static {
      this.ɵfac = function ConfigureCartEntryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfigureCartEntryComponent)(i0.ɵɵdirectiveInject(CommonConfiguratorUtilsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfigureCartEntryComponent,
        selectors: [["cx-configure-cart-entry"]],
        inputs: {
          cartEntry: "cartEntry",
          readOnly: "readOnly",
          msgBanner: "msgBanner",
          disabled: "disabled"
        },
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [["configureText", ""], [4, "ngIf"], ["class", "disabled-link", 4, "ngIf"], ["class", "link cx-action-link", "cxAutoFocus", "", 3, "routerLink", "queryParams", 4, "ngIf"], [1, "disabled-link"], [4, "ngIf", "ngIfThen"], ["cxAutoFocus", "", 1, "link", "cx-action-link", 3, "routerLink", "queryParams"]],
        template: function ConfigureCartEntryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ConfigureCartEntryComponent_ng_container_0_Template, 4, 1, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.abstractOrderKey$));
          }
        },
        dependencies: [i3.NgIf, i3$1.RouterLink, i3.AsyncPipe, i4.UrlPipe, i4.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ConfigureCartEntryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfigureCartEntryModule = /*#__PURE__*/(() => {
  class ConfigureCartEntryModule {
    static {
      this.ɵfac = function ConfigureCartEntryModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfigureCartEntryModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ConfigureCartEntryModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, UrlModule, I18nModule, IconModule, RouterModule]
      });
    }
  }
  return ConfigureCartEntryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfiguratorIssuesNotificationComponent = /*#__PURE__*/(() => {
  class ConfiguratorIssuesNotificationComponent {
    constructor(commonConfigUtilsService, cartItemContext) {
      this.commonConfigUtilsService = commonConfigUtilsService;
      this.cartItemContext = cartItemContext;
      this.iconTypes = ICON_TYPE;
      this.orderEntry$ = this.cartItemContext?.item$ ?? EMPTY;
      this.quantityControl$ = this.cartItemContext?.quantityControl$ ?? EMPTY;
      this.readonly$ = this.cartItemContext?.readonly$ ?? EMPTY;
      // TODO: remove the logic below when configurable products support "Saved Cart" and "Save For Later"
      this.shouldShowButton$ = this.commonConfigUtilsService.isActiveCartContext(this.cartItemContext);
    }
    /**
     * Verifies whether the item has any issues.
     *
     * @param item - Cart item
     * @returns - whether there are any issues
     */
    hasIssues(item) {
      return this.commonConfigUtilsService.hasIssues(item);
    }
    /**
     * Retrieves the number of issues at the cart item.
     *
     * @param item - Cart item
     * @returns - the number of issues at the cart item
     */
    getNumberOfIssues(item) {
      return this.commonConfigUtilsService.getNumberOfIssues(item);
    }
    /**
     * Retrieves the unique id for the error message.
     *
     * @param item - Cart item
     * @returns - Unique id for error message
     */
    getErrorMessageId(item) {
      return 'cx-error-msg-' + item.entryNumber;
    }
    static {
      this.ɵfac = function ConfiguratorIssuesNotificationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorIssuesNotificationComponent)(i0.ɵɵdirectiveInject(CommonConfiguratorUtilsService), i0.ɵɵdirectiveInject(i2.CartItemContext, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfiguratorIssuesNotificationComponent,
        selectors: [["cx-configurator-issues-notification"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [3, "type"], [3, "id"], ["class", "cx-error-msg-action", 3, "cartEntry", "readOnly", "msgBanner", "disabled", 4, "ngIf"], [1, "cx-error-msg-action", 3, "cartEntry", "readOnly", "msgBanner", "disabled"]],
        template: function ConfiguratorIssuesNotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ConfiguratorIssuesNotificationComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.orderEntry$));
          }
        },
        dependencies: [i3.NgIf, i1.IconComponent, ConfigureCartEntryComponent, i3.AsyncPipe, i4.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return ConfiguratorIssuesNotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfiguratorIssuesNotificationModule = /*#__PURE__*/(() => {
  class ConfiguratorIssuesNotificationModule {
    static {
      this.ɵfac = function ConfiguratorIssuesNotificationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorIssuesNotificationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ConfiguratorIssuesNotificationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: CartOutlets.ITEM_CONFIGURATOR_ISSUES,
          position: OutletPosition.REPLACE,
          component: ConfiguratorIssuesNotificationComponent
        })],
        imports: [CommonModule, UrlModule, I18nModule, IconModule, ConfigureCartEntryModule]
      });
    }
  }
  return ConfiguratorIssuesNotificationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfiguratorCartEntryInfoComponent = /*#__PURE__*/(() => {
  class ConfiguratorCartEntryInfoComponent {
    constructor(cartItemContext, commonConfigUtilsService) {
      this.cartItemContext = cartItemContext;
      this.commonConfigUtilsService = commonConfigUtilsService;
      this.orderEntry$ = this.cartItemContext?.item$ ?? EMPTY;
      this.quantityControl$ = this.cartItemContext?.quantityControl$ ?? EMPTY;
      this.readonly$ = this.cartItemContext?.readonly$ ?? EMPTY;
      // TODO: remove the logic below when configurable products support "Saved Cart" and "Save For Later"
      this.shouldShowButton$ = this.commonConfigUtilsService.isActiveCartContext(this.cartItemContext);
    }
    /**
     * Verifies whether the configuration infos have any entries and the first entry has a status.
     * Only in this case we want to display the configuration summary
     *
     * @param {OrderEntry} item - Cart item
     * @returns {boolean} - whether the status of configuration infos entry has status
     */
    hasStatus(item) {
      const configurationInfos = item.configurationInfos;
      return configurationInfos ? configurationInfos.length > 0 && configurationInfos[0].status !== 'NONE' : false;
    }
    /**
     * Verifies whether the configurator type is attribute based one.
     *
     * @param {OrderEntry} item - Order entry item
     * @returns {boolean} - 'True' if the expected configurator type, otherwise 'fasle'
     */
    isAttributeBasedConfigurator(item) {
      const configurationInfos = item.configurationInfos;
      return configurationInfos ? this.commonConfigUtilsService.isAttributeBasedConfigurator(configurationInfos[0]?.configuratorType) : false;
    }
    getHiddenConfigurationInfoId(index) {
      return 'cx-configuration-hidden-info-' + index.toString();
    }
    static {
      this.ɵfac = function ConfiguratorCartEntryInfoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorCartEntryInfoComponent)(i0.ɵɵdirectiveInject(i2.CartItemContext, 8), i0.ɵɵdirectiveInject(CommonConfiguratorUtilsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfiguratorCartEntryInfoComponent,
        selectors: [["cx-configurator-cart-entry-info"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], ["class", "cx-intro cx-visually-hidden", 4, "ngIf"], ["class", "cx-configuration-info", 4, "ngFor", "ngForOf"], [1, "cx-intro", "cx-visually-hidden"], [1, "cx-configuration-info"], [1, "cx-visually-hidden", 3, "id"], ["aria-hidden", "true", 1, "cx-label"], ["aria-hidden", "true", 1, "cx-value"], [3, "cartEntry", "readOnly", "msgBanner", "disabled", 4, "ngIf"], [3, "cartEntry", "readOnly", "msgBanner", "disabled"]],
        template: function ConfiguratorCartEntryInfoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ConfiguratorCartEntryInfoComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.orderEntry$));
          }
        },
        dependencies: [i3.NgForOf, i3.NgIf, ConfigureCartEntryComponent, i3.AsyncPipe, i4.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return ConfiguratorCartEntryInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfiguratorCartEntryInfoModule = /*#__PURE__*/(() => {
  class ConfiguratorCartEntryInfoModule {
    static {
      this.ɵfac = function ConfiguratorCartEntryInfoModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorCartEntryInfoModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ConfiguratorCartEntryInfoModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: CartOutlets.ITEM_DETAILS,
          position: OutletPosition.AFTER,
          component: ConfiguratorCartEntryInfoComponent
        })],
        imports: [CommonModule, UrlModule, I18nModule, IconModule, ConfiguratorIssuesNotificationModule, ConfigureCartEntryModule]
      });
    }
  }
  return ConfiguratorCartEntryInfoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ConfiguratorProductScope = /*#__PURE__*/function (ConfiguratorProductScope) {
  ConfiguratorProductScope["CONFIGURATOR"] = "configurator";
  ConfiguratorProductScope["CONFIGURATOR_PRODUCT_CARD"] = "configuratorProductCard";
  return ConfiguratorProductScope;
}(ConfiguratorProductScope || {});
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfigureProductComponent = /*#__PURE__*/(() => {
  class ConfigureProductComponent {
    getProduct() {
      if (this.productListItemContext) {
        return this.productListItemContext.product$;
      }
      return this.currentProductService ? this.currentProductService.getProduct([ProductScope.DETAILS, ConfiguratorProductScope.CONFIGURATOR]) : of(null);
    }
    /**
     * Retrieves a translation key for aria-label depending on the condition.
     *
     * @param configuratorType - configurator type
     * @returns - If the configurator type contains a read-only postfix then 'configurator.a11y.showDetailsProduct' translation key will be returned,
     * otherwise 'configurator.a11y.configureProduct'.
     */
    getAriaLabelTranslationKey(configuratorType) {
      return this.isConfiguratorTypeReadOnly(configuratorType) ? 'configurator.a11y.showDetailsProduct' : 'configurator.a11y.configureProduct';
    }
    /**
     * Retrieves a translation key depending on the condition.
     *
     * @param configuratorType - configurator type
     * @returns - If the configurator type contains a read-only postfix then 'configurator.header.toConfigReadOnly' translation key will be returned,
     * otherwise 'configurator.header.toconfig'.
     */
    getTranslationKey(configuratorType) {
      return this.isConfiguratorTypeReadOnly(configuratorType) ? 'configurator.header.toConfigReadOnly' : 'configurator.header.toconfig';
    }
    /**
     * Verifies whether restart dialog should be displayed or not.
     *
     * @param configuratorType
     * @returns - If the configurator type contains a read-only postfix then false will be returned, otherwise true.
     */
    isDisplayRestartDialog(configuratorType) {
      return this.isConfiguratorTypeReadOnly(configuratorType) ? 'false' : 'true';
    }
    /**
     * Verifies whether a configurator type of a product contains a read-only postfix and
     * a product is a base product.
     *
     * @param product - product
     * @returns - If the configurator type contains a read-only postfix and
     * a product is a base product then returns true, otherwise false.
     */
    isReadOnlyBaseProduct(product) {
      return this.isConfiguratorTypeReadOnly(product.configuratorType) && this.isBaseProduct(product);
    }
    /**
     * Verifies whether a product is a base product.
     *
     * The `baseProduct` property contains the product code of the base product.
     * If the `baseProduct` is undefined or if the provided product code equals the code of the base product,
     * then this product is a base product.
     *
     * @param product - product
     * @returns - If a product is a base product then returns true, otherwise false.
     * @protected
     */
    isBaseProduct(product) {
      return !product.baseProduct || product.baseProduct === product.code;
    }
    navigateToConfigurator(product) {
      this.routingService?.go({
        cxRoute: 'configure' + product.configuratorType,
        params: {
          ownerType: this.ownerTypeProduct,
          entityKey: product.code
        }
      }, {
        queryParams: {
          displayRestartDialog: this.isDisplayRestartDialog(product.configuratorType),
          productCode: product.code
        }
      });
    }
    isConfiguratorTypeReadOnly(configuratorType) {
      return !!configuratorType && configuratorType.trim().endsWith(ReadOnlyPostfix);
    }
    constructor(productListItemContext,
    // when on PLP
    currentProductService // when on PDP
    ) {
      this.productListItemContext = productListItemContext;
      this.currentProductService = currentProductService;
      this.nonConfigurable = {
        configurable: false
      };
      this.product$ = this.getProduct().pipe(
      //needed because also currentProductService might return null
      map(product => product ? product : this.nonConfigurable));
      this.ownerTypeProduct = CommonConfigurator.OwnerType.PRODUCT;
      this.routingService = inject(RoutingService, {
        optional: true
      });
    }
    static {
      this.ɵfac = function ConfigureProductComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfigureProductComponent)(i0.ɵɵdirectiveInject(i1.ProductListItemContext, 8), i0.ɵɵdirectiveInject(i1.CurrentProductService, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfigureProductComponent,
        selectors: [["cx-configure-product"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], ["cxAutoFocus", "", 1, "btn", "btn-primary", "btn-block", 3, "click"]],
        template: function ConfigureProductComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ConfigureProductComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.product$));
          }
        },
        dependencies: [i3.NgIf, i3.AsyncPipe, i4.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ConfigureProductComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfigureProductModule = /*#__PURE__*/(() => {
  class ConfigureProductModule {
    static {
      this.ɵfac = function ConfigureProductModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfigureProductModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ConfigureProductModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: ProductListOutlets.ITEM_ACTIONS,
          position: OutletPosition.AFTER,
          component: ConfigureProductComponent
        })],
        imports: [CommonModule, RouterModule, ConfigModule.withConfig({
          cmsComponents: {
            ConfigureProductComponent: {
              component: ConfigureProductComponent
            }
          }
        }), UrlModule, I18nModule, IconModule, BtnLikeLinkModule]
      });
    }
  }
  return ConfigureProductModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service for mapping of the CPQ line items from order entry
 */
let ConfiguratorCartEntryBundleInfoService = /*#__PURE__*/(() => {
  class ConfiguratorCartEntryBundleInfoService {
    constructor() {
      this.logger = inject(LoggerService);
    }
    /**
     * Retrieves the CPQ line items for an order entry
     *
     * @param {OrderEntry} entry - Order entry
     * @returns {LineItem[]} - Line item array
     */
    retrieveLineItems(entry) {
      let lineItems = [];
      if (entry.configurationInfos) {
        const configurationInfos = entry.configurationInfos.filter(configurationInfo => configurationInfo && (configurationInfo.configurationLabel || configurationInfo.configurationValue));
        const firstLabel = configurationInfos[0]?.configurationLabel;
        const firstValue = configurationInfos[0]?.configurationValue;
        if (firstLabel !== ConfigurationInfoSpecialFields.VERSION) {
          configurationInfos.forEach(configurationInfo => lineItems.push(this.prepareLineItem(configurationInfo)));
        } else if (firstLabel === ConfigurationInfoSpecialFields.VERSION && Number(firstValue) >= 2) {
          lineItems = this.processConfigurationInfos(configurationInfos);
        } else {
          this.logWarning('Wrong ConfigurationInfo version');
        }
      }
      return lineItems;
    }
    prepareLineItem(configurationInfo) {
      const quantityAndPrice = configurationInfo.configurationValue ? configurationInfo.configurationValue.split('x') : [];
      return {
        name: configurationInfo.configurationLabel ? this.removeDelimiter(configurationInfo.configurationLabel) : '',
        formattedQuantity: quantityAndPrice.length >= 1 ? quantityAndPrice[0].trim() : '',
        formattedPrice: quantityAndPrice.length >= 2 ? quantityAndPrice[1].trim() : ''
      };
    }
    removeDelimiter(label) {
      let preparedLabel = label.trim();
      const lastCharacter = preparedLabel.charAt(preparedLabel.length - 1);
      if (lastCharacter === ':') {
        preparedLabel = preparedLabel.substring(0, preparedLabel.length - 1);
      }
      return preparedLabel;
    }
    processConfigurationInfos(configurationInfos) {
      const lineItemMap = new Map();
      configurationInfos.forEach(configurationInfo => this.processConfigurationInfoEntry(lineItemMap, configurationInfo));
      // sort
      const lineItemMapSorted = new Map(Array.from(lineItemMap).sort((a, b) => {
        return a[0] - b[0];
      }));
      // convert to array
      const lineItems = Array.from(lineItemMapSorted.values());
      return lineItems;
    }
    processConfigurationInfoEntry(lineItemMap, configurationInfo) {
      if (configurationInfo.configurationLabel) {
        const configurationInfoSplit = configurationInfo.configurationLabel.split(ConfigurationInfoSpecialFields.LINE_ITEM_DELIMITER);
        if (configurationInfoSplit[0] === ConfigurationInfoSpecialFields.LINE_ITEM) {
          const configurationInfoValue = configurationInfo.configurationValue ? configurationInfo.configurationValue : '';
          this.addLineItemData(lineItemMap, configurationInfoSplit, configurationInfoValue);
        }
      }
    }
    addLineItemData(lineItemMap, configurationInfoSplit, configurationInfoValue) {
      if (configurationInfoSplit.length === 3) {
        const lineItemNumber = Number(configurationInfoSplit[1]);
        let lineItem;
        switch (configurationInfoSplit[2]) {
          case ConfigurationInfoFields.NAME:
            lineItem = this.getOrCreateLineItem(lineItemMap, lineItemNumber);
            lineItem.name = configurationInfoValue;
            break;
          case ConfigurationInfoFields.QTY:
            lineItem = this.getOrCreateLineItem(lineItemMap, lineItemNumber);
            lineItem.formattedQuantity = configurationInfoValue;
            break;
          case ConfigurationInfoFields.FORMATTED_PRICE:
            lineItem = this.getOrCreateLineItem(lineItemMap, lineItemNumber);
            lineItem.formattedPrice = configurationInfoValue;
            break;
          case ConfigurationInfoFields.KEY:
          case ConfigurationInfoFields.PRICE_VALUE:
            break;
          default:
            {
              this.logWarning('Wrong LineItem format');
            }
        }
      } else {
        this.logWarning('Wrong LineItem format');
      }
    }
    getOrCreateLineItem(lineItemMap, lineItemNumber) {
      const lineItem = lineItemMap.get(lineItemNumber) ?? {
        name: '',
        formattedQuantity: '',
        formattedPrice: ''
      };
      if (!lineItemMap.get(lineItemNumber)) {
        lineItemMap.set(lineItemNumber, lineItem);
      }
      return lineItem;
    }
    logWarning(text) {
      if (isDevMode()) {
        this.logger.warn(text);
      }
    }
    static {
      this.ɵfac = function ConfiguratorCartEntryBundleInfoService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorCartEntryBundleInfoService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfiguratorCartEntryBundleInfoService,
        factory: ConfiguratorCartEntryBundleInfoService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConfiguratorCartEntryBundleInfoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Requires default change detection strategy, as the disabled state of the quantity from control may change,
 * which would not be proper detected with onPush strategy.
 */
let ConfiguratorCartEntryBundleInfoComponent = /*#__PURE__*/(() => {
  class ConfiguratorCartEntryBundleInfoComponent {
    constructor(commonConfigUtilsService, configCartEntryBundleInfoService, breakpointService, translation, cartItemContext) {
      this.commonConfigUtilsService = commonConfigUtilsService;
      this.configCartEntryBundleInfoService = configCartEntryBundleInfoService;
      this.breakpointService = breakpointService;
      this.translation = translation;
      this.cartItemContext = cartItemContext;
      this.orderEntry$ = this.cartItemContext?.item$ ?? EMPTY;
      this.quantityControl$ = this.cartItemContext?.quantityControl$ ?? EMPTY;
      this.readonly$ = this.cartItemContext?.readonly$ ?? EMPTY;
      this.hideItems = true;
      this.lineItems$ = this.orderEntry$.pipe(map(entry => this.configCartEntryBundleInfoService.retrieveLineItems(entry)));
      this.numberOfLineItems$ = this.lineItems$.pipe(map(items => items.length));
      // TODO: remove the logic below when configurable products support "Saved Cart" and "Save For Later"
      this.shouldShowButton$ = this.commonConfigUtilsService.isActiveCartContext(this.cartItemContext);
    }
    /**
     * Toggles the state of the items list.
     */
    toggleItems() {
      this.hideItems = !this.hideItems;
    }
    /**
     * Verifies whether the configurator type is a bundle based one.
     *
     * @param {OrderEntry} entry - Order entry
     * @returns {boolean} - 'true' if the expected configurator type, otherwise 'false'
     */
    isBundleBasedConfigurator(entry) {
      const configInfos = entry.configurationInfos;
      return configInfos ? this.commonConfigUtilsService.isBundleBasedConfigurator(configInfos[0]?.configuratorType) : false;
    }
    getButtonText(translatedText) {
      if (!translatedText) {
        translatedText = '';
      }
      if (this.hideItems) {
        this.translation.translate('configurator.header.show').pipe(take(1)).subscribe(text => translatedText += text);
      } else {
        this.translation.translate('configurator.header.hide').pipe(take(1)).subscribe(text => translatedText += text);
      }
      return translatedText;
    }
    getItemsMsg(items) {
      let translatedText = '';
      this.translation.translate('configurator.a11y.cartEntryBundleInfo', {
        items: items
      }).pipe(take(1)).subscribe(text => translatedText = text);
      return this.getButtonText(translatedText);
    }
    getHiddenItemInfo(item) {
      let translatedText = '';
      if (item.name && item.formattedPrice && item.formattedQuantity) {
        this.translation.translate('configurator.a11y.cartEntryBundle', {
          name: item.name,
          price: item.formattedPrice,
          quantity: item.formattedQuantity
        }).pipe(take(1)).subscribe(text => translatedText = text);
      } else if (item.name && item.formattedPrice) {
        this.translation.translate('configurator.a11y.cartEntryBundleNameWithPrice', {
          name: item.name,
          price: item.formattedPrice
        }).pipe(take(1)).subscribe(text => translatedText = text);
      } else if (item.name && item.formattedQuantity) {
        this.translation.translate('configurator.a11y.cartEntryBundleNameWithQuantity', {
          name: item.name,
          quantity: item.formattedQuantity
        }).pipe(take(1)).subscribe(text => translatedText = text);
      } else {
        this.translation.translate('configurator.a11y.cartEntryBundleName', {
          name: item.name
        }).pipe(take(1)).subscribe(text => translatedText = text);
      }
      return translatedText;
    }
    getHiddenItemInfoId(index) {
      return 'cx-item-hidden-info-' + index.toString();
    }
    static {
      this.ɵfac = function ConfiguratorCartEntryBundleInfoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorCartEntryBundleInfoComponent)(i0.ɵɵdirectiveInject(CommonConfiguratorUtilsService), i0.ɵɵdirectiveInject(ConfiguratorCartEntryBundleInfoService), i0.ɵɵdirectiveInject(i1.BreakpointService), i0.ɵɵdirectiveInject(i4.TranslationService), i0.ɵɵdirectiveInject(i2.CartItemContext, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfiguratorCartEntryBundleInfoComponent,
        selectors: [["cx-configurator-cart-entry-bundle-info"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "cx-number-items"], [3, "click"], [1, "cx-toggle-hide-items"], [1, "cx-item-infos"], ["class", "cx-item-info", 4, "ngFor", "ngForOf"], [1, "cx-item-info"], [1, "cx-visually-hidden", 3, "id"], ["aria-hidden", "true", 1, "cx-item-name"], ["aria-hidden", "true", 1, "cx-item-quantity"], ["aria-hidden", "true", 1, "cx-item-price"], [1, "cx-identifier"], [1, "cx-item"], [3, "cartEntry", "readOnly", "msgBanner", "disabled", 4, "ngIf"], [3, "cartEntry", "readOnly", "msgBanner", "disabled"]],
        template: function ConfiguratorCartEntryBundleInfoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ConfiguratorCartEntryBundleInfoComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.orderEntry$));
          }
        },
        dependencies: [i3.NgForOf, i3.NgIf, ConfigureCartEntryComponent, i3.AsyncPipe, i4.TranslatePipe, i4.CxNumericPipe],
        encapsulation: 2
      });
    }
  }
  return ConfiguratorCartEntryBundleInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ConfiguratorCartEntryBundleInfoModule = /*#__PURE__*/(() => {
  class ConfiguratorCartEntryBundleInfoModule {
    static {
      this.ɵfac = function ConfiguratorCartEntryBundleInfoModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorCartEntryBundleInfoModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ConfiguratorCartEntryBundleInfoModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideOutlet({
          id: CartOutlets.ITEM_BUNDLE_DETAILS,
          position: OutletPosition.AFTER,
          component: ConfiguratorCartEntryBundleInfoComponent
        })],
        imports: [CommonModule, I18nModule, ConfigureCartEntryModule]
      });
    }
  }
  return ConfiguratorCartEntryBundleInfoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CommonConfiguratorComponentsModule = /*#__PURE__*/(() => {
  class CommonConfiguratorComponentsModule {
    static {
      this.ɵfac = function CommonConfiguratorComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommonConfiguratorComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CommonConfiguratorComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [ConfiguratorIssuesNotificationModule, ConfiguratorCartEntryInfoModule, ConfiguratorCartEntryBundleInfoModule, ConfigureCartEntryModule, ConfigureProductModule]
      });
    }
  }
  return CommonConfiguratorComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultOccConfiguratorProductConfig = {
  backend: {
    occ: {
      endpoints: {
        product: {
          configurator: 'products/${productCode}?fields=code,configurable,configuratorType',
          configuratorProductCard: 'products/${productCode}?fields=code,description,images(DEFAULT)'
        }
      }
    },
    loadingScopes: {
      product: {
        list: {
          include: [ConfiguratorProductScope.CONFIGURATOR]
        }
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CommonConfiguratorOccModule = /*#__PURE__*/(() => {
  class CommonConfiguratorOccModule {
    static {
      this.ɵfac = function CommonConfiguratorOccModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommonConfiguratorOccModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CommonConfiguratorOccModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultOccConfiguratorProductConfig)]
      });
    }
  }
  return CommonConfiguratorOccModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CommonConfiguratorModule = /*#__PURE__*/(() => {
  class CommonConfiguratorModule {
    static {
      this.ɵfac = function CommonConfiguratorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommonConfiguratorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CommonConfiguratorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonConfiguratorOccModule, CommonConfiguratorComponentsModule]
      });
    }
  }
  return CommonConfiguratorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ConfiguratorRouter;
(function (ConfiguratorRouter) {
  let PageType;
  (function (PageType) {
    PageType["CONFIGURATION"] = "configuration";
    PageType["OVERVIEW"] = "overview";
  })(PageType = ConfiguratorRouter.PageType || (ConfiguratorRouter.PageType = {}));
})(ConfiguratorRouter || (ConfiguratorRouter = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service to extract the configuration owner key from the current route
 */
let ConfiguratorRouterExtractorService = /*#__PURE__*/(() => {
  class ConfiguratorRouterExtractorService {
    constructor(configUtilsService, routingService) {
      this.configUtilsService = configUtilsService;
      this.routingService = routingService;
      this.ROUTE_FRAGMENT_CONFIGURE = 'configure';
      this.ROUTE_FRAGMENT_OVERVIEW = 'configureOverview';
    }
    extractRouterData() {
      return this.routingService.getRouterState().pipe(filter(routingData => routingData.state.params.entityKey),
      //we don't need to cover the intermediate router states where a future route is already known.
      //only changes to the URL are relevant. Otherwise we get wrong hits where e.g. the config form fires although
      //the OV already loads
      filter(routingData => routingData.nextState === undefined), map(routingData => {
        const owner = this.createOwnerFromRouterState(routingData);
        const semanticRoute = routingData.state.semanticRoute;
        const routerData = {
          owner: owner,
          isOwnerCartEntry: owner.type === CommonConfigurator.OwnerType.CART_ENTRY,
          displayOnly: routingData.state.params.displayOnly,
          resolveIssues: routingData.state.queryParams?.resolveIssues === 'true',
          skipConflicts: routingData.state.queryParams?.skipConflicts === 'true',
          forceReload: routingData.state.queryParams?.forceReload === 'true',
          expMode: routingData.state.queryParams?.expMode === 'true',
          displayRestartDialog: routingData.state.queryParams?.displayRestartDialog === 'true',
          configIdTemplate: routingData.state.queryParams?.configIdTemplate,
          navigationId: routingData.navigationId,
          pageType: semanticRoute && semanticRoute.includes(this.ROUTE_FRAGMENT_OVERVIEW) ? ConfiguratorRouter.PageType.OVERVIEW : ConfiguratorRouter.PageType.CONFIGURATION,
          navigateToCheckout: routingData.state.queryParams?.navigateToCheckout === 'true',
          productCode: routingData.state.queryParams?.productCode
        };
        return routerData;
      }));
    }
    createOwnerFromRouterState(routerState) {
      const owner = ConfiguratorModelUtils.createInitialOwner();
      const params = routerState.state.params;
      if (params.ownerType) {
        const entityKey = params.entityKey;
        owner.type = params.ownerType;
        owner.id = entityKey;
      } else {
        owner.type = CommonConfigurator.OwnerType.PRODUCT;
        owner.id = params.rootProduct;
      }
      const semanticRoute = routerState.state.semanticRoute;
      if (semanticRoute) {
        const configuratorType = this.getConfiguratorTypeFromSemanticRoute(semanticRoute);
        owner.configuratorType = configuratorType;
      }
      this.configUtilsService.setOwnerKey(owner);
      return owner;
    }
    /**
     * Compiles the configurator type from the semantic route
     * @param semanticRoute Consists of a prefix that indicates if target is interactive configuration or overview and
     *                      the commerce configurator type as postfix.
     *                      Example: configureTEXTFIELD or configureOverviewCPQCONFIGURATOR
     * @returns Configurator type
     */
    getConfiguratorTypeFromSemanticRoute(semanticRoute) {
      if (semanticRoute.startsWith(this.ROUTE_FRAGMENT_OVERVIEW)) {
        return semanticRoute.split(this.ROUTE_FRAGMENT_OVERVIEW)[1];
      } else if (semanticRoute.startsWith(this.ROUTE_FRAGMENT_CONFIGURE)) {
        return semanticRoute.split(this.ROUTE_FRAGMENT_CONFIGURE)[1];
      } else {
        throw new Error('Not able to determine configurator type');
      }
    }
    static {
      this.ɵfac = function ConfiguratorRouterExtractorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfiguratorRouterExtractorService)(i0.ɵɵinject(CommonConfiguratorUtilsService), i0.ɵɵinject(i4.RoutingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConfiguratorRouterExtractorService,
        factory: ConfiguratorRouterExtractorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConfiguratorRouterExtractorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** AUGMENTABLE_TYPES_END */

/**
 * Generated bundle index. Do not edit.
 */

export { CommonConfigurator, CommonConfiguratorComponentsModule, CommonConfiguratorModule, CommonConfiguratorOccModule, CommonConfiguratorUtilsService, ConfigurationInfoFields, ConfigurationInfoSpecialFields, ConfiguratorCartEntryBundleInfoComponent, ConfiguratorCartEntryBundleInfoModule, ConfiguratorCartEntryBundleInfoService, ConfiguratorCartEntryInfoComponent, ConfiguratorCartEntryInfoModule, ConfiguratorIssuesNotificationComponent, ConfiguratorIssuesNotificationModule, ConfiguratorModelUtils, ConfiguratorProductScope, ConfiguratorRouter, ConfiguratorRouterExtractorService, ConfiguratorType, ConfigureCartEntryComponent, ConfigureCartEntryModule, ConfigureProductComponent, ConfigureProductModule, OrderEntryStatus, ReadOnlyPostfix };
